export const screenMirroringI18n = {
    en: {
        normalLabel: 'Normal',
        bookLabel: 'PC',
        paperLabel: 'Tablet',
        screenModeValidationTitle: 'PC & Tablet Mode',
        screenModeValidationMessage: 'Please select in which mode you want to use this device',
        screenModeValidationPaperDisclaimer: 'Your {deviceName} will be set up as PC',
        screenModeValidationBookDisclaimer: 'Your {deviceName} will be set up as Tablet',
        normalModeLabel: 'Normal',
        paperModeLabel: 'Tablet Mode',
        bookModeLabel: 'PC Mode',
        accept:'Accept',
        ignore:'Ignore',
        
        device : {
            browser : 'Browser',
            desktop : 'Desktop',
            tablet : 'Tablet',
            'Mobile Phone' : 'Mobile Phone',
        }
    },
    es: {
        normalLabel: 'Normal',
        bookLabel: 'PC',
        paperLabel: 'Tablet',
        screenModeValidationTitle: 'Modo PC & Tablet',
        screenModeValidationMessage: 'Selecciona el modo en el que deseas usar este dispositivo',
        screenModeValidationPaperDisclaimer: 'Su dispositivo {deviceName} será configurado como PC',
        screenModeValidationBookDisclaimer: 'Su dispositivo {deviceName} será configurado como Tablet',
        normalModeLabel: 'Normal',
        paperModeLabel: 'Modo Tablet',
        bookModeLabel: 'Modo PC',
        accept:'Acceptar',
        ignore:'Ignorar',

        device : {
            browser : 'Navegador',
            desktop : '',
            tablet : 'Tablet',
            'Mobile Phone' : 'Móvil',
        }
    }
};

